import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IMAGE_FILE_ALLOWED, MAX_SIZE_FILE, TYPE_FILE_ALLOWED } from '@app/@core/constants/requests.constants';
import { FileUpload } from '@app/requests/model/requests-model';

@Component({
  selector: 'scf-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateComponent implements OnInit {
  @Input() numFile: number;
  @Input() isDifferentFromRequests: boolean = false;
  @Output() saveFile = new EventEmitter<FileUpload>();
  @ViewChild('description') descriptionElement: ElementRef;

  srcResult: string;
  iconCircle: string;
  fileUpload: File;
  nameFile: string;
  loadFile: boolean = false;
  validationError: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.iconCircle = 'check_circle';
  }

  selectFile(event: any): void {
    let description: string = '';
    this.fileUpload = event.target.files[0];
    if (this.fileUpload) {
      //validation of size
      if (this.fileUpload.size <= 0 || this.fileUpload.size > MAX_SIZE_FILE) {
        this.validationError = true;
        this.nameFile = 'El formato o peso del archivo no es válido';
        this.iconCircle = 'cancel';
      } else if (!IMAGE_FILE_ALLOWED.includes(this.fileUpload.type)) {
        this.validationError = true;
        this.nameFile = 'El formato o peso del archivo no es válido';
        this.iconCircle = 'cancel';
      } else {
        this.validationError = false;
        this.iconCircle = 'check_circle';
        this.nameFile = event.target.files[0].name;
        this.loadFile = true;
        this.saveFile.emit({ numFile: this.numFile, file: this.fileUpload, description: description });
      }
      event.target.value = ''; //Clears the input so the same file can be selected again
    } else {
      this.loadFile = false;
      this.saveFile.emit({ numFile: this.numFile, file: this.fileUpload, description: description });
      this.descriptionElement.nativeElement.value = '';
    }
  }

  getDescription(value: any) {
    let description: string = value;
    this.saveFile.emit({ numFile: this.numFile, file: this.fileUpload, description: description });
  }

  onFileSelected() {
    const inputNode: any = document.querySelector('#file');

    if (typeof FileReader !== 'undefined') {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        this.srcResult = e.target.result;
      };

      reader.readAsArrayBuffer(inputNode.files[0]);
    }
  }

  reset() {
    this.loadFile = false;
    this.validationError = false;
    this.fileUpload = null;
    this.getDescription('');
  }
}
